<template>
  <div class="search-page">
    <SearchOptions />
    <SearchMultiInput
      :types="searchOptions"
      :selectedType="searchOptions[0]"
      :class="{ 'search-open': searchBlock }"
    />

    <div v-if="searching" class="search-page-searching">
      <b-progress :value="100" variant="info" striped :animated="true" class="mb-2"></b-progress>
    </div>

    <div v-else class="search-products" :class="search.kindList">
      <div class="product-view-list-header">
        <div class="product-header-image">Zdjęcie</div>
        <div class="product-header-name">Nazwa</div>
        <div class="product-header-producer">Producent / symbol producenta</div>
        <div class="product-header-ean">Kod kreskowy</div>
        <div class="product-header-stock">Stan</div>
        <div class="product-header-price">Cena</div>
        <div class="product-header-action"></div>
      </div>
      <div
        v-for="product in products"
        class="product-item"
        :class="[product.stock > 0 ? 'accessible' : 'inaccessible']"
      >
        <!-- <div v-if="product.groups.includes('promocje')" class="product-promotion-info">
          <span>promocja</span>
        </div>
        <div v-if="product.groups.includes('nowość')" class="product-news-info">
          <span>nowość</span>
        </div>-->

        <router-link
          class="product-item-image"
          :to="{
            name: 'productPage',
            params: { id: product.id, slug: 'item' }
          }"
        >
          <img :src="formatImageSource(product.image)" :alt="product.name" class="img-fluid" />
        </router-link>
        <router-link
          class="product-item-name"
          :to="{
            name: 'productPage',
            params: { id: product.id, slug: 'item' }
          }"
        >
          <span class="product-item-mobile-label">nazwa</span>
          <span>{{ Cms.decode(product.name) }}</span>
        </router-link>

        <div class="producer">
          <div class="product-item-producer">
            <span class="product-item-mobile-label">producent</span>
            <span>{{ Cms.decode(product.producer) }}</span>
          </div>
          <div class="product-item-producer-code">
            <span class="product-item-mobile-label">symbol producenta</span>
            <span>{{ product.code }}</span>
          </div>
        </div>
        <div class="product-item-ean">
          <span class="product-item-mobile-label">kod kreskowy</span>
          <barcode :value="product.ean" format="EAN13" width="1" height="60"></barcode>
        </div>

        <div class="product-item-stock">
          <span v-if="product.stock > 0" class="product-item-mobile-label">stan:  {{product.stock}}</span>
          <span v-if="product.stock <= 0" class="badge badge-secondary p-2" >niedostępny</span>
        </div>

        <div v-if="product.stock > 0" class="product-item-price">
          <span class="product-item-mobile-label">cena</span>
          <span v-if="userSettings.B2B_CLIENT_PRICE_TYPE == 'net'">netto</span>
          <span v-else>brutto</span>
          <span class="price">{{ clientPrice(product) }}</span>
          <div class="discount" v-if="discountPrice(product) > 0">
            <label>cena katalogowa</label>
            <span class="before-price">{{ netPrice(product) }}</span>
            <span class="discount-percent">Rabat: {{ discountPrice(product) }} %</span>
          </div>
        </div>
        <div v-if="product.stock > 0" class="product-item-action">
          <div class="action-descriptions">
            <small class="form-text text-muted action-description">Dodaj do koszyka</small>
            <small
              class="form-text text-muted action-description"
              v-if="offerEnable"
            >Dodaj do oferty</small>
          </div>
          <div class="action-buttons">
            <div class="button" @click="addToBasket(product)">
              <span class="button-text">Dodaj do koszyka</span>
              <cart-plus-icon title="dodaj do koszyka" />
            </div>

            <div v-if="offerEnable" class="button" @click="addToOffer(product)">
              <span class="button-text">Dodaj do oferty</span>
              <book-plus-icon title="dodaj do oferty" />
            </div>
          </div>
        </div>

        <div v-else-if="purchaseInaccessibleProducts" class="product-item-inaccessible">
          <div class="button" @click="addToBasket(product)">
            <span class="button-text">Zapytaj opiekuna handlowego</span>
            <help-box-icon title="dodaj do koszyka" />
          </div>
        </div>
        <!-- <div v-else class="item-missing">produkt chwilowo niedostępny</div> -->
        <!-- <ul v-if="product.gratis.length > 0" class="product-item-gratis alert alert-info">
          Przy zakupie:
          <li class="product-item-gratis-info" v-for="gratis in product.gratis">
            <span>{{gratis.Rangefrom}} - {{gratis.Rangeto}}</span>
            sztuk otrzymujesz
            <span>{{gratis.Gratiscount}}x gratis</span>
          </li>
          <img src="./../../assets/icons/info.svg" alt="Info Icon" class="search-page-info-icon" />
        </ul>-->
      </div>
    </div>

    <div class="search-page-pagination-bottom">
      <b-pagination
        align="right"
        :total-rows="search.page.count"
        v-model="search.page.current"
        :per-page="search.page.limit"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VueBarcode from "vue-barcode";

import {
  BPagination,
  BProgress,
  BFormSelect,
  BFormCheckbox
} from "../BootstrapElements";

import SearchOptions from "./SearchOptions.vue";

import { Cms } from "../RedbayComponents";
import Product from "./../products/src/product/Product";
import CalculatePrice from "./../products/src/product/CalculatePrice";
import ViewListIcon from "vue-material-design-icons/ViewList.vue";
import ViewModuleIcon from "vue-material-design-icons/ViewModule.vue";
import SortAscendingIcon from "vue-material-design-icons/SortAlphabetical.vue";
import SortDescendingIcon from "vue-material-design-icons/SortDescending.vue";
import CartIcon from "vue-material-design-icons/Cart.vue";
import CartPlusIcon from "vue-material-design-icons/CartPlus.vue";
import CalculatorIcon from "vue-material-design-icons/Calculator.vue";
import Adjust from "vue-material-design-icons/Adjust.vue";
import SortAlphabetical from "vue-material-design-icons/SortAlphabetical.vue";
import SortNumeric from "vue-material-design-icons/SortNumeric.vue";
import BookPlusIcon from "vue-material-design-icons/BookPlus.vue";
import HelpBoxIcon from "vue-material-design-icons/HelpBox.vue";

import SearchMultiInput from "./../layout/src/input/SearchMultiInput.vue";

import NoImage from "./../../assets/images/no-img.png";

export default {
  components: {
    barcode: VueBarcode,
    HelpBoxIcon,
    BookPlusIcon,
    CalculatorIcon,
    CartPlusIcon,
    CartIcon,
    SortDescendingIcon,
    SortAscendingIcon,
    ViewModuleIcon,
    ViewListIcon,
    Adjust,
    SortAlphabetical,
    SortNumeric,
    BPagination,
    BProgress,
    BFormSelect,
    BFormCheckbox,
    SearchOptions,
    SearchMultiInput
  },
  data() {
    return {
      searchOptions: "",
      searching: false,
      products: [],
      optionsLimit: [],
      producers: [],
      filters: {
        attributes: []
      },
      Cms: Cms,
      offerEnable: false,
      purchaseInaccessibleProducts: false,
      noImage: NoImage
    };
  },

  computed: {
    ...mapState({
      shop: state => state.shop,
      search: state => state.search,
      reload: state => state.search.reload,
      page: state => state.search.page,
      userSettings: state => state.user.userSettings,
      brands: state => state.brands,
      selectedProd: state => state.categories.selectedProd,
      searchBlock: state => state.searchBlock
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },
  watch: {
    reload: function() {
      this.findResults();
    },
    limit: function() {
      this.findResults();
    },
    sort: function() {
      this.findResults();
    }
  },

  methods: {
    ...CalculatePrice(),

    clientPrice(product) {
      return this.calculateClientPrice(
        product.clientPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
    },
    formatImageSource(source) {
      return source.includes("noimg") ? this.noImage : source;
    },
    netPrice(product) {
      return this.calculateClientPrice(
        product.netPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
    },
    discountPrice(product) {
      let client = this.calculateClientPriceValue(
        product.clientPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
      let net = this.calculateClientPriceValue(
        product.netPrice,
        product.tax,
        "net",
        this.userSettings,
        this.currency()
      );
      return net > 0 ? Math.round((1 - client / net) * 100) : 0;
    },

    async findResults() {
      if (!this.searching) {
        let group = this.userSettings["USER_GROUP"]
          ? this.userSettings["USER_GROUP"]
          : 0;
        this.searching = true;
        let results = await this.$store.dispatch(
          "search/requestData",
          this.filters
        );
        this.searching = false;
        this.products = results.documentList.map(pr =>
          Product.buildProduct(
            pr,
            this.$config.get("searchPage.visibleAttributes"),
            [],
            group
          )
        );
        this.$store.state.search.page = results.page;

        this.$store.dispatch(
          "brands/setFilters",
          Product.buildFilter(results, "Producer")
        );
        this.$store.dispatch(
          "categories/setFilters",
          Product.buildFilter(results, "Category")
        );
        this.$store.dispatch(
          "search/setBuiltFilters",
          this.filters.attributes
            .map(f =>
              Object.create({
                name: f.name,
                values: Product.buildFilter(results, f.name)
              })
            )
            .filter(f => f.values.length > 0)
        );
      }
    },

    async addToBasket(product) {
      await this.$store.dispatch("basket/addToBasket", {
        id: product.variantId,
        cart_quantity: 1
      });
      this.$store.dispatch("openRightWindow");
      this.$noty.success("Produkt dodany do koszyka!");
    },

    async addToOffer(product) {
      this.$store.dispatch("offer/add", {
        productId: product.id,
        variantId: product.variantId
      });
      this.$store.dispatch("openRightWindowOffer");
      this.$noty.info("Produkt dodany do oferty!");
    }
  },

  async beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    await this.$store.dispatch("user/getUserSettings");
    this.optionsLimit = this.$config.get("searchPage.optionsLimit");
    this.$store.dispatch("search/loadKindList");
    this.filters = this.$config.get("searchPage.filters");
    this.offerEnable = this.$config.get("offer.enable");
    let setting = this.shop.settings.find(s => s.name == "IPH_ASK_SALESMAN");
    this.purchaseInaccessibleProducts = setting && setting.value == 1;
    this.$store.commit("categories/clearSelected");
    this.$store.dispatch("search/getGroups");
    console.log(this.searchOptions);

    this.findResults();
  },
  mounted() {
    this.searchOptions = this.$config.get("header.main.searchOptions");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/SearchPage.vue